import React from "react";
import PropTypes from "prop-types";

export const withTranslations = (locales) => (WrappedComponent) => {
  return class extends React.Component {
    static propTypes = {
      locale: PropTypes.object,
    };

    constructor(props) {
      super(props);

      if (props.locale) {
        locales.setLanguage(props.locale);
      } else if (document.body.getAttribute("locale")) {
        const documentLocale = document.body.getAttribute("locale");
        locales.setLanguage(documentLocale);
      }
    }

    render() {
      return <WrappedComponent locales={locales} {...this.props} />;
    }
  };
};
